import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

/**
 * Reusable per-page selector for paginated grids and tables.
 * @param {number} value - Current items per page
 * @param {function} onChange - Callback when value changes (receives number)
 * @param {number[]} options - Available page size options
 * @param {string} label - Label suffix (e.g., "labs", "courses")
 */
export function PageSizeSelector({ value, onChange, options = [12, 24, 48], label = 'items' }) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500" data-testid="page-size-selector">
      <span>Show</span>
      <Select
        value={String(value)}
        onValueChange={(v) => onChange(Number(v))}
      >
        <SelectTrigger className="w-[70px] h-8 text-xs" data-testid="page-size-trigger">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt} value={String(opt)} data-testid={`page-size-${opt}`}>
              {opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span>per page</span>
    </div>
  );
}
